<template>
<div class="c-product">
  <div class="c-product__text">
    <span></span>
  </div>
  <div class="c-product__head">
    <h2>
      <span>LINE UP</span>
    </h2>
  </div>
  <div class="c-product__items">
    <div class="c-item">
      <div class="c-item__head">
        <h3>
          <span>GOLD</span>
          <span>K18</span>
        </h3>
        <p>G-22 series</p>
      </div>
      <ul class="c-item__list">
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/goldk18-1@2x.png`" alt="Gold K18" width="270" height="72" /></li>
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/goldk18-2@2x.png`" alt="Gold K18" width="270" height="83" /></li>
      </ul>
      <div class="c-item__btn">
        <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}gold/`"
          >
            <span>Detail</span>
          </router-link>
      </div>
    </div>

    <div class="c-item">
      <div class="c-item__head">
        <h3>
          <span>TORTOISESHELL</span>
          <span v-if="$store.getters.lang === 'ja'">鼈甲</span>
        </h3>
        <p>NP-10B series</p>
      </div>
      <ul class="c-item__list">
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/tortoiseshell-1@2x.png`" alt="Tortoise Shell" width="270" height="77" /></li>
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/tortoiseshell-2@2x.png`" alt="Tortoise Shell" width="270" height="77" /></li>
      </ul>
      <div class="c-item__btn">
        <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}tortoiseshell/`"
          >
            <span>Detail</span>
          </router-link>
      </div>
    </div>

    <div class="c-item">
      <div class="c-item__head">
        <h3>
          <span>TORTOISESHELL</span>
          <span v-if="$store.getters.lang === 'ja'">鼈甲</span>
        </h3>
        <p>S-647T series</p>
      </div>
      <ul class="c-item__list">
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/tortoiseshell-3@2x.png`" alt="Tortoise Shell" width="270" height="77" /></li>
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/tortoiseshell-4@2x.png`" alt="Tortoise Shell" width="270" height="77" /></li>
      </ul>
      <div class="c-item__btn">
        <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}tortoiseshell/?scrollto=c-modelList__head--1`"
          >
            <span>Detail</span>
          </router-link>
      </div>
    </div>

    <div class="c-item">
      <div class="c-item__head">
        <h3>
          <span>BUFFALO HORN</span>
          <span v-if="$store.getters.lang === 'ja'">バッファローホーン</span>
        </h3>
        <p>NP-16BF series</p>
      </div>
      <ul class="c-item__list">
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/buffalohorn-1@2x.png`" alt="Buffalo Horn" width="270" height="83" /></li>
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/buffalohorn-2@2x.png`" alt="Buffalo Horn" width="270" height="77" /></li>
        <li><img :src="`${$store.getters.assetsPath}img/top/lineup/buffalohorn-3@2x.png`" alt="Buffalo Horn" width="270" height="78" /></li>
      </ul>
      <div class="c-item__btn">
        <router-link 
          class="c-btnMore1" 
          :to="`/${$store.getters.pathPrefix}buffalohorn/`"
          >
            <span>Detail</span>
          </router-link>
      </div>
    </div>
  </div>
  <ul class="c-product__exlink">
    <li>
      <a class="c-btnEx c-btnEx--ex" :href="`/collections/2022autumn-luxury/${$store.getters.pathPrefix}`" target="_blank">LUXURY 2022</a>
    </li>
    <li>
      <a class="c-btnEx c-btnEx--insta" href="https://www.instagram.com/999.9_fournines/" target="_blank">999.9 Official <br class="u-none-b--sp" />Instagram</a>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>